<template>
  <div>

    <div class="row mx-1 mt-1">
      <b-select v-model="perPage" :options="pageOptions" class="pageSizeClass">
      </b-select>
    </div>
    <b-table 
      :busy="!evaluations "
      :items="evaluations"
      :fields="fields"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :per-page="perPage"
      :current-page="currentPage"
      responsive
      show-empty
      ref="evaluationsTable"
      class="mt-2"
      thead-class="esep-blue-bg text-light"
    >
      <template v-slot:cell(status)="row">
          <b-icon :icon="isCompleted(row.item)===0? 'circle': isCompleted(row.item)===1? 'check-circle-fill': 'circle-half'"
                  :variant="isCompleted(row.item)===0? 'danger': isCompleted(row.item)===1? 'success': 'warning'"
                  :title="`${isCompleted(row.item).toFixed(2)*100}% Συμπληρωμένο`"
          ></b-icon>
      </template>

      <template v-slot:cell(action)="row"> 
        <b-button
          size="sm"
          @click="goToEvaluation(row.item.participation.activity)"
          variant="transparent"
          v-b-tooltip.hover
          :title="$t('evaluations.goToEvaluation')"
        >
          <b-icon icon="box-arrow-right" ></b-icon>
        </b-button>
      </template>

      <template v-slot:empty="">
        <h6>{{ $t("evaluations.emptyEvaluationsTable") }}</h6>
      </template>

      <template #table-busy>
        <div class="text-center my-2">
          <b-spinner class="align-middle"></b-spinner>
        </div>
      </template>

    </b-table>

    <b-row>
      <b-col>
        <b-pagination
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          align="right"
          aria-controls="evaluations-table"
          variant="info"
        ></b-pagination>
      </b-col>
    </b-row>
  </div>
</template>

<script>

export default {
  computed: {
    rows() {
      return this.evaluations? this.evaluations.length : 0;
    }
  },
  props: {
    evaluations: Array,
    trainer: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      pageOptions: [
        10,
        20,
        50,
        {
          value: Number.MAX_SAFE_INTEGER,
          text: "All",
        },
      ],
      sortBy: "member",
      sortDesc: false,
      fields: [
        { key: "status", label: "", sortable: false },
        { key: "participation.activity.activityNo", label: "Αριθμός Εκπ.", sortable: true }, // needs to be translated
        { key: "participation.activity.module", label: "Περιγραφή", sortable: true ,filterByFormatted: true, formatter: 'showTitle', thClass: 'text-left', tdClass: 'text-left' },
        { key: "participation.activity.leaders", label: "Αρχηγός", sortable: true , filterByFormatted: true, formatter: 'showLeader', thClass: 'text-left', tdClass: 'text-left'},
        { key: "participation.activity.periods", label: "Ημ/νιες Διεξαγωγής", sortable: true , filterByFormatted: true, formatter: 'showPeriods' , tdClass: 'maxWidth'},
        { key: "action", label: "Ενέργειες", sortable: false },
      ]
    }
  },
  methods: {
    showTitle(mod) {
      return mod.title;
    },
    showLeader(leaders) {
      let leaderTrainer = '-';
      leaders.forEach(leader => {
        if(leader.position == 'LEADER') {
          leaderTrainer = leader.member.surName + ' ' + leader.member.firstName;
        }
      });
      return leaderTrainer;
    },
    showPeriods(periods) {
      let periodText = '';
      if(periods.length > 0) {
        for (let i = 0; i < periods.length; i++) {
          const period = periods[i];
          let startDate = new Date(period.startDate);
          let endDate = new Date(period.endDate);
          periodText += `${startDate.toLocaleString()}   - ${endDate.toLocaleString()} (${period.location})`;
          if(periods.length > 1 && i < periods.length -1) {
            periodText += ` , `;
          }
        }
      } else {
        periodText = '-';
      }
      return periodText;
    },
    goToEvaluation(activity) {
      if (this.trainer){
        window.location.href = `/app/training/web/evaluations/activity/${activity.id}/trainer`;
      } else {
        window.location.href = `/app/training/web/evaluations/activity/${activity.id}/trainee`;
      }
    },
    isCompleted(evalItem) {
      let criteriaCount = evalItem.criteriaCount;
      let evalCount = evalItem.evaluationsCount;
      evalItem.sessions.forEach(session => {
        criteriaCount += session.criteriaCount;
        evalCount += session.evaluationsCount;
      })

      return evalCount / criteriaCount;
    }
  }
}
</script>